import {
  extractApiMessageFromError,
  resolveApiMessage,
  type IntlLike,
} from './apiMessageUtils';

type ApiError = {
  data?: {
    message?: string;
  };
  message?: string;
  response?: {
    data?: {
      message?: string;
    };
  };
};

export const getErrorMessage = (
  error: unknown,
  defaultMessage: string,
  intl?: IntlLike
): string => {
  if (intl) {
    return resolveApiMessage(
      extractApiMessageFromError(error),
      intl,
      defaultMessage
    );
  }

  const typedError = error as ApiError;

  return (
    typedError?.data?.message ||
    typedError?.response?.data?.message ||
    typedError?.message ||
    defaultMessage
  );
};
